import React from 'react';
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch';
import './style.css';
import { Form, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

/**
 * Props for the ConfigToggleOption component.
 */
interface ConfigToggleOptionProps {
  /** Label text displayed next to the toggle switch. */
  label?: string;
  /** Whether the toggle switch is enabled. */
  isFeatureEnabled?: boolean;
  /** Callback function triggered when the toggle state changes. */
  onChange?: (checked: boolean) => void;
  /** Name for form integration (can be a string or an array of strings). */
  name?: string | string[];
  /** Whether the toggle switch is disabled. */
  disabled?: boolean;
  /** Tooltip title displayed when hovering over the toggle switch. */
  title?: string;
  /** Tooltip information displayed next to the label. */
  infoTitle?: string;
}

/**
 * A toggle switch component with an optional label, tooltip, and form integration.
 *
 * @param {ConfigToggleOptionProps} props - The component props.
 * @returns {JSX.Element} The rendered ConfigToggleOption component.
 */
const ConfigToggleOption: React.FC<ConfigToggleOptionProps> = ({
  label = '',
  isFeatureEnabled = false,
  onChange,
  name,
  disabled = false,
  title = '',
  infoTitle = '',
}) => {
  return (
    <div id="configToggleOptionLabelWrapper" className="configToggleOptionLabelWrapper">
      <div className="configToggleOptionLabel">
        {label}{' '}
        {infoTitle && (
          <Tooltip title={infoTitle}>
            <InfoCircleOutlined style={{ color: '#6852d6', marginLeft: 4 }} />
          </Tooltip>
        )}
      </div>
      {title ? (
        <Tooltip title={title}>
          <Form.Item name={name} valuePropName="checked">
            <ToggleSwitch checked={isFeatureEnabled} onChange={onChange} disabled={disabled} />
          </Form.Item>
        </Tooltip>
      ) : (
        <Form.Item name={name} valuePropName="checked">
          <ToggleSwitch checked={isFeatureEnabled} onChange={onChange} disabled={disabled} />
        </Form.Item>
      )}
    </div>
  );
};

export default ConfigToggleOption;
